import { AppGroup } from 'shared/constants/apps'

export const LAUNCHPAD_APP_GROUPS = [
  AppGroup.WORKFORCE_MANAGEMENT,
  AppGroup.OFFICE_TOOLS,
  AppGroup.COMMUNICATION,
  AppGroup.BUSINESS_TOOLS,
  AppGroup.CONFIGURATION
]
